var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AppinfoService } from './appinfo.service';
import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';
import { AppSettings } from './../app.settings';
import { BehaviorSubject, Subject } from 'rxjs';
import { Router } from '@angular/router';
import WKT from 'ol/format/WKT';
var LayerService = /** @class */ (function () {
    function LayerService(router, appinfoService, requestService, userService) {
        this.router = router;
        this.appinfoService = appinfoService;
        this.requestService = requestService;
        this.userService = userService;
        this.layersRefreshed = new Subject();
        this.layerListBS = new BehaviorSubject({
            layers: [],
            publishedLayers: []
        });
        // layerList: AppLayer[] = []; // Both loaded and UNloaded layers // Not including published layers
        // publishedLayerList: AppLayer[] = [];
        this.fishboneLayer = {
            layerType: 'FISHBONE',
            name: 'Fishbone Report',
            isFishbone: true,
            category: {
                code: 'fishbone'
            }
            // id: null,
            // category: null,
            // desc: null,
            // recordCount: null,
            // loadDate: null,
            // isBuiltTopo: null,
            // state: null,
            // maintainType: null
        };
        this.bdryLayerList = [];
    }
    // Get raw layer list
    LayerService.prototype.getRawLayers = function (customerId, layerTypeId, history) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/layers';
            customerId = customerId || _this.userService.getUserInfo().customerId;
            var params = {
                customerId: customerId.toString()
            };
            if (layerTypeId) {
                params.layerId = layerTypeId.toString();
            }
            if (history) {
                params.history = true;
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) { return resolve(rsp); }, function (err) { return reject(err); });
        });
    };
    // Get layer list // The returned list does NOT include published layers
    LayerService.prototype.getLayers = function (customerId, statusOnly, keepOriginalList, layerTypeId, history) {
        var _this = this;
        console.log('gggggggggggg getLayers');
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/layers';
            var params = {};
            customerId = customerId || _this.userService.getCustomerIdByType();
            if (!customerId) {
                resolve([]);
                return;
            }
            params.customerId = customerId.toString();
            if (layerTypeId) {
                params.layerId = layerTypeId.toString();
            }
            if (history) {
                params.history = true;
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                // const promises = [];
                var layers = [];
                var publishedLayers = [];
                if (rsp.data) {
                    rsp.data.forEach(function (l) {
                        var layer = {
                            id: l.gly_id,
                            name: l.gly_name,
                            desc: l.gly_desc,
                            category: _this.appinfoService.layerTypeList.find(function (t) { return t.id === l.gly_glt_id; }),
                            recordCount: l.gly_rowcount,
                            loadDate: l.gly_load_date,
                            isBuiltTopo: l.is_topo_built,
                            maintainType: l.gly_maint_type,
                            cusId: l.gly_cus_id,
                            // state: (() => {
                            // 	var a;
                            // 	a = Math.floor(Math.random() * 6);
                            // 	return a;
                            // })()
                            state: (function () {
                                return _this.mapTextToLayerLoadState(l.lol_state);
                                // switch (l.lol_state) {
                                // 	case 'APPROVE': return 5;
                                // 	case 'DISAPPROVE': return 4;
                                // 	case 'SUBMIT': return 3;
                                // 	case 'CONTENT': return 2;
                                // 	case 'SCHEMA': return 1.51;
                                // 	case 'TOPOLOGY': return 1.52;
                                // 	case 'DOMAIN': return 1.53;
                                // 	case 'CREATE': return 1;
                                // 	default: return 0; // Not loaded layer
                                // }
                            })()
                        };
                        if (layer.maintainType === 'SNAPSHOT') {
                            publishedLayers.push(layer);
                        }
                        else {
                            layers.push(layer);
                        }
                        // if (layer.state === 2) {
                        // 	promises.push(new Promise((resolveL, rejectL) => {
                        // 		this.layerQcService.getQcErrorCount(l.gly_id)
                        // 		.then((count) => {
                        // 			layer.qcErrorCount = count;
                        // 			resolveL();
                        // 		}, err => rejectL(err));
                        // 	}));
                        // }
                    });
                }
                // Promise.all(promises)
                // .catch((err) => {
                // 	console.log('Error on getting qcErrorCount: ', err);
                // 	resolve(layers);
                // })
                // .then(() => {
                if (!keepOriginalList) {
                    _this.layerListBS.next({
                        layers: layers,
                        publishedLayers: publishedLayers,
                        statusOnly: statusOnly
                    });
                    // this.layerList = layers;
                    // this.publishedLayerList = publishedLayers;
                }
                resolve(layers);
                // });
            }, function (err) { return reject(err); });
        });
    };
    LayerService.prototype.mapTextToLayerLoadState = function (stateText) {
        var num;
        switch (stateText) {
            case 'APPROVE':
                num = 5;
                break;
            case 'DISAPPROVE':
                num = 4;
                break;
            case 'SUBMIT':
                num = 3;
                break;
            case 'CONTENT':
                num = 2;
                break;
            case 'SCHEMA':
                num = 1.51;
                break;
            case 'TOPOLOGY':
                num = 1.52;
                break;
            case 'DOMAIN':
                num = 1.53;
                break;
            case 'CREATE':
                num = 1;
                break;
            default:
                num = 0;
                break; // Not loaded layer
        }
        return {
            name: stateText,
            num: num
        };
    };
    LayerService.prototype.getLiveLayerFromLayerList = function (layerList) {
        layerList = layerList || this.layerListBS.getValue().layers;
        return layerList.filter(function (l) { return !!l.state && (l.maintainType === 'LIVE' || l.maintainType === 'COLLABORATIVE'); });
    };
    // Get layer contents
    LayerService.prototype.getLayerContents = function (layerId, gfo, paging, model) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/layerContents';
            var params = {
                glyId: layerId.toString()
            };
            // Set paging params
            if (paging) {
                _this.requestService.setParamsPaging(params, paging);
            }
            // Set gfo
            if (gfo) {
                params.gfo = JSON.stringify(gfo);
            }
            if (model) {
                params.model = model;
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp);
            }, function (err) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    reject(err);
                    return [2 /*return*/];
                });
            }); });
        });
    };
    LayerService.prototype.getLayerGeometry = function (layerId, uuid, gfo) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/layerGeometry';
            var params = {
                layerId: layerId.toString(),
            };
            if (uuid) {
                params.uuId = uuid;
            }
            if (gfo) {
                params.gfo = JSON.stringify(gfo);
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp);
            }, function (err) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    // await this.checkLayerNotFoundError(err, cusId, layerId);
                    reject(err);
                    return [2 /*return*/];
                });
            }); });
        });
    };
    LayerService.prototype.deleteLayer = function (layerId, successCallback, errorCallback) {
        var url = AppSettings.serviceRootUrl + 'azgiv/layers';
        this.requestService.requestDelete(url, {
            params: {
                layerId: layerId.toString(),
                userSubscriptionId: this.userService.getUserInfo().userSubId
            }
        }, function (rsp) {
            if (successCallback) {
                successCallback();
            }
        }, errorCallback);
    };
    LayerService.prototype.purgeLayer = function (glyId, successCallback, errorCallback) {
        var url = AppSettings.serviceRootUrl + 'azgiv/purgeLayer';
        var body = {
            glyId: glyId,
            userSubscriptionId: this.userService.getUserInfo().userSubId
        };
        this.requestService.requestPost(url, body, function (rsp) {
            if (successCallback) {
                successCallback();
            }
        }, errorCallback);
    };
    // Post
    LayerService.prototype.publishLayers = function (layerIds, restore) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/publishLayers';
            var body = {
                layerIds: JSON.stringify(layerIds),
                userSubscriptionId: _this.userService.getUserInfo().userSubId
            };
            if (restore) {
                body.restore = restore;
            }
            _this.requestService.requestPost(url, body, function (rsp) {
                resolve(rsp);
            }, function (err) { return reject(err); });
        });
    };
    LayerService.prototype.updateLayerStatus = function (layerId, layerStatus) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/layer';
            var body = {
                userSubscriptionId: _this.userService.getUserInfo().userSubId,
                layerId: layerId,
                layerStatus: layerStatus
            };
            _this.requestService.requestPut(url, body, function (rsp) { return resolve(rsp); }, function (err) { return reject(err); });
        });
    };
    // Note: this is only for MatchPoint bdry use. For other NENA layer use Discrepancy Agency!!!
    LayerService.prototype.getCustomerBoundaryGeom = function (customerId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/customerBoundaryGeom';
            var params = {
                customerId: customerId || _this.userService.getUserInfo().customerId
            };
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                var boundaries = [];
                if (rsp.data) {
                    rsp.data.forEach(function (d) {
                        boundaries.push({
                            cusId: d.cus_id,
                            wkt: d.geom,
                            stateName: d.stn_name
                        });
                    });
                }
                resolve(boundaries);
            }, function (err) { return reject(err); });
        });
    };
    LayerService.prototype.getLayerGeomBoundingBox = function (layerId, extent, isGeojson) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/layerGeomBbox';
            var params = {
                layerId: layerId.toString(),
                xll: extent[0].toString(),
                yll: extent[1].toString(),
                xur: extent[2].toString(),
                yur: extent[3].toString(),
                geojson: isGeojson
            };
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp.data);
            }, function (err) { return reject(err); });
        });
    };
    LayerService.prototype.getLoadableLayerTypeList = function (usbId, isTestLayer) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/layerTypeList';
            var params = {
                userSubscriptionId: usbId
            };
            if (isTestLayer) {
                params.test = isTestLayer;
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                var loadable = [];
                if (rsp.data) {
                    rsp.data.forEach(function (i) {
                        loadable.push({
                            code: i.glt_cd,
                            loadable: i.loadable,
                            maintainType: i.gly_maint_type,
                            usbId: i.usb_id
                        });
                    });
                }
                resolve(loadable);
            }, function (err) { return reject(err); });
        });
    };
    // Get archive layer list
    LayerService.prototype.getTestLayerList = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/layerTypeList';
            var params = {
                customerId: _this.userService.customerInfo.id,
                test: true
            };
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                var layers = [];
                if (rsp.data) {
                    rsp.data.forEach(function (i) {
                        layers.push({
                            code: i.glt_cd,
                            id: i.gly_id
                        });
                    });
                }
                resolve(layers);
            }, function (err) { return reject(err); });
        });
    };
    // Get boundary layers for reference use. It might not belong to current agency
    // Note: one type could have more than one layerIds
    LayerService.prototype.getBdryLayers = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/layersBoundary';
            var params = {
                customerId: _this.userService.getUserInfo().customerId
            };
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                var bdryLayers = [];
                if (rsp.data) {
                    rsp.data.forEach(function (d) {
                        var cate = _this.appinfoService.layerTypeList.find(function (i) { return i.id === d.gly_glt_id; });
                        bdryLayers.push({
                            gltId: d.gly_glt_id,
                            cateCode: d.glt_cd,
                            label: cate.nameShort,
                            layers: d.layers ? d.layers.map(function (l) {
                                return {
                                    id: l.layer_id,
                                    state: _this.mapTextToLayerLoadState(l.layer_state),
                                    maintainType: l.layer_maint_type
                                };
                            }) : []
                            // layerIds: d.gly_ids 
                        });
                    });
                }
                _this.bdryLayerList = bdryLayers;
                resolve(bdryLayers);
            }, function (err) { return reject(err); });
        });
    };
    LayerService.prototype.getRefLayerAttrList = function (cateCode, model) {
        var info = this.appinfoService.refLayerMvtAttrs[cateCode];
        if (!info) {
            return '';
        }
        if (!model) {
            model = 'N';
        }
        if (!info[model]) {
            model = 'N';
        }
        var attrList = info[model].attrList;
        return attrList;
    };
    LayerService.prototype.getFilterCount = function (layerId, extent, gfo) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/filterCount';
            var params = {
                layerId: layerId
            };
            if (gfo) {
                params.gfo = JSON.stringify(gfo);
            }
            if (extent) {
                params.xll = extent[0];
                params.yll = extent[1];
                params.xur = extent[2];
                params.yur = extent[3];
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                resolve(rsp.data[0]);
            }, function (err) { return reject(err); });
        });
    };
    LayerService.prototype.getAddressTileMinDist = function (layerId, extent, zoomLevel) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/ssapDist';
            var params = {
                layerId: layerId,
                z: zoomLevel,
                xll: extent[0],
                yll: extent[1],
                xur: extent[2],
                yur: extent[3]
            };
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                var wktFormat = new WKT();
                if (rsp.data.pt1) {
                    rsp.data.pt1 = wktFormat.readGeometry(rsp.data.pt1).getCoordinates();
                }
                if (rsp.data.pt2) {
                    rsp.data.pt2 = wktFormat.readGeometry(rsp.data.pt2).getCoordinates();
                }
                resolve(rsp.data);
            }, function (err) { return reject(err); });
        });
    };
    LayerService.prototype.getSsapByRcl = function (rcId, model) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = AppSettings.serviceRootUrl + 'azgiv/ssapByRcl';
            var cusId = _this.userService.getCustomerIdByType();
            var params = {
                customerId: cusId,
                rclGrdId: rcId
            };
            if (model) {
                params.model = model;
            }
            _this.requestService.requestGet(url, {
                params: params
            }, function (rsp) {
                console.log(rsp);
                resolve(rsp);
            }, function (err) { return reject(err); });
        });
    };
    // getRclBySsap(gadId, model?: ModelMenuItemKey) {
    // 	return new Promise<{addrGlobalId; rclGlobalId}[]>((resolve, reject) => {
    // 		const url = AppSettings.serviceRootUrl + 'azgiv/rclBySsap';
    // 		const cusId = this.userService.getCustomerIdByType();
    // 		const params: any = {
    // 			customerId: cusId,
    // 			ssapGadId: gadId
    // 		}
    // 		if (model) {
    // 			params.model = model;
    // 		}
    // 		this.requestService.requestGet(url, {
    // 			params: params
    // 		}, rsp => {
    // 			const list: {addrGlobalId; rclGlobalId}[] = [];
    // 			if (rsp.data) {
    // 				rsp.data.forEach(i => list.push({
    // 					addrGlobalId: i.gad_globalid,
    // 					rclGlobalId: i.grd_globalid
    // 				}));
    // 			}
    // 			resolve(list);
    // 		}, err => reject(err))
    // 	});
    // }
    LayerService.prototype.getSourceTableNameByLayerCate = function (cateCode) {
        var layerType = this.appinfoService.layerTypeList.find(function (i) { return i.code === cateCode; });
        return layerType ? layerType.tableName : '';
    };
    LayerService.prototype.getLayerLabelByCateCode = function (cateCode) {
        if (!cateCode) {
            return '';
        }
        var layer = this.layerListBS.getValue().layers.find(function (l) { return l.category.code === cateCode; });
        var name = layer.category.name;
        return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    };
    return LayerService;
}());
export { LayerService };
